/* Imports */
import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './components/auth.module';
import { userTable } from './components/user_table.module';
import { rolesTable } from './components/roles_table.module'
import { incidentTable } from './components/incidents_table.module';
import { teams } from './components/teams.module';
/* /Imports/ */

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    userTable,
    rolesTable,
    incidentTable,
    teams
  }
});